<template>
    <div>
          <h5 class="card-title">Assign Document</h5>            
          <div class="row">
            <div class="col-md-12 col-xs-12">
              <fg-input
                placeholder="Search Document"
                v-model="SearchedDoc"
                v-on:input="GetFilteredDocument"
              ></fg-input>
            </div>
          </div>
           <div id="table-scroll">
           <ul class="list-group" v-for="doc in filteredDocumentList" :key="doc.id">
             <li @click="MessageDialog(doc.id)" class="list-group-item row no-gutters py-2 liStyling">
               <i class="fa fa-file-text-o mr-2 fa-2x" aria-hidden="true"></i>{{doc.short_name}} | {{doc.title}}
               </li>
           </ul>
         </div>
        <el-dialog
        :visible.sync="MessageDialogModal"
        :center='true'
        :append-to-body="true"
         width="80%">
        <ResourceMessageForm :docId="documentId" @close-modal="CloseResourceFormModal"></ResourceMessageForm>
      </el-dialog>
    </div>
</template>
<script>
import resourcesServices from "src/services/Resources/resourcesServices.js"
import ResourceMessageForm from "@/components/Dashboard/Views/Resource/ResourceMessageForm.vue"
export default {
  components:{
  resourcesServices,
  ResourceMessageForm
  },
    data(){
        return{
         MessageDialogModal:false,
         SearchedDoc:"",
           documentList:[],
           filteredDocumentList:[],
           documentId:""
        };
    },
  methods:{
      MessageDialog(id){
         this.MessageDialogModal=true; 
        this.documentId=id;
       },
    async ResourceDocuments(){
        var practice = this.$store.getters["currentUser/getCurrentUsersPractice" ];
         var docList=await resourcesServices.GetResourceDocumentList(practice);
         this.documentList=docList.result;
         this.filteredDocumentList=this.documentList;
      },
      GetFilteredDocument(){
        var t = this;
      this.filteredDocumentList = this.documentList.filter(
        (item) => {
          return (
            item.short_name
              .toLowerCase()
              .indexOf(t.SearchedDoc.toLowerCase()) > -1
          );
        }
      );
      return this.filteredDocumentList;
      },
      CloseResourceFormModal(){
        this.MessageDialogModal=false; 
      }
  },
 async created(){
   await this.ResourceDocuments()
  }
}
</script>
<style scoped>
#table-scroll {
  height:350px;
  overflow:auto;  
  margin-top:20px;
}
.liStyling{
  cursor:pointer;
  word-break: initial;
}

</style>